import { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';

import './style.scss';
import MessageItem from '../message-item';
import MediaContainer from '../../../common/MediaContainer';
import { bannedWords } from '../../../utils/helper';
import { FOLLOW_STATUS, MESSAGE_TYPE } from '../../../utils/constants';
import CloseButton from '../../../common/CloseButton';
import { MediaContainerContext } from '../../../common/MediaContainer/MediaContainerContext';
import { setAlert } from '../../../../redux/actions';
import pusher from '../../../utils/pusher';
import useDidMountEffect from '../../../utils/useDidMountEffect';
import { setChatGalleryActiveMessage } from '../../../../redux/actions/chatGallery';

const IndividualMessage = ({
    activeMessage
}) => {
    const { id } = useParams();
    const isMountedRef = useRef(true);
    const history = useHistory();
    const dispatch = useDispatch();
    const search = useLocation().search;
    const searchParams = new URLSearchParams(search);

    const [busy, setBusy] = useState(false);
    const [processingIntent, setProcessingIntent] = useState(false);

    const getMessage = async () => {
        setBusy(true);
        await axios.get(`/api/messages/${id}`)
            .then(response => {
                if (!isMountedRef.current) return null;
                setBusy(false);
                dispatch(setChatGalleryActiveMessage(response.data));
            })
            .catch(error => {
                setBusy(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Message not found'
                }));
            });
    };

    useEffect(() => {
        if (isMountedRef.current) {
            getMessage();
        }

        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const handleClose = () => {
        history.push('/messages');
    };

    const handlePaymentIntent = (d) => {
        console.log(d);
        let message = '';
        let type = 'info';
        if (d.status) {
            getMessage();
            message = `Your payment for ${d.puLogin} has been successfully processed`;
            type = 'success';
        } else {
            message = `The purchase has been denied by your bank due to the unsuccessful 3D Secure authentication. You may try again or contact your bank or use another payment card.`;
            if (d.errorCode === 0) {
                message = 'Your card has insufficient funds';
            }
            type = 'error';
        }

        dispatch(setAlert({
            show: true,
            type: type,
            body: message
        }));
    };

    useEffect(() => {
        const isIntent = searchParams.get('payment_intent') && searchParams.get('payment_intent_client_secret');
        if (isIntent) {
            // listen for payment status events
            const subscription = pusher.subscribe(`private-intent-${localStorage.getItem('loggedin_user')}`);
            subscription.bind('App\\Events\\PaymentIntentEvent', d => {
                handlePaymentIntent(d);
            });
        }

        return () => {
            pusher.unsubscribe(`private-intent-${localStorage.getItem('loggedin_user')}`);
        };
    }, []);

    return <div className='container individual-message'>
        {
            busy
                ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                    <Spinner size="md" animation='border' variant='primary' />
                </div>
                : <>
                    <div className='individual-message__container'>
                        <div className="d-fex">
                            <CloseButton
                                onClick={handleClose}
                                className='close'
                            />
                        </div>
                        <div className={'message-caption mb-2'}>
                            {
                                Object.keys(activeMessage).length > 0
                                    ? bannedWords(activeMessage.message)
                                    : null
                            }
                        </div>
                        {
                            Object.keys(activeMessage).length > 0
                                ? <div style={{ position: 'relative' }}>
                                    <MediaContainerContext.Provider value={{ processingIntent }}>
                                        <MediaContainer
                                            message={activeMessage}
                                        />
                                    </MediaContainerContext.Provider>
                                </div>
                                : null
                        }
                    </div>
                </>
        }

    </div>;
};

const mapStateToProps = (state) => {
    return {
        activeMessage: state.chatGallery.activeMessage
    };
};

export default connect(mapStateToProps)(IndividualMessage);